/**
 * @file picking-view.ts
 * @description Режим экрана заданий на сборку: очередь или журнал
 * (phase19.14, довесок к экрану A).
 *
 * Режим живёт в URL (`?view=history`), а не в состоянии страницы: «Назад» из
 * карточки задания обязано вернуть кладовщика туда, откуда он ушёл.
 */

/** Режимы экрана заданий. */
export type PickingView = "queue" | "history";

/** Значение `?view=` в URL; всё неизвестное — очередь. */
export function parsePickingView(raw: string | null): PickingView {
  return raw === "history" ? "history" : "queue";
}

/** Подписи переключателя режимов — один источник для вкладок и заголовков. */
export const PICKING_VIEW_LABEL: Record<PickingView, string> = {
  queue: "Очередь",
  history: "Журнал",
};
